export function clampNumber(num, lowerBound, upperBound) {
  return Math.max(
    Math.min(num, Math.max(lowerBound, upperBound)),
    Math.min(lowerBound, upperBound),
  );
}
